import { issueMeta } from "@/mocks/home";

export default function HeroCover() {
  return (
    <section className="relative w-full">
      <div className="relative h-[580px] w-full overflow-hidden md:h-[720px]">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20collage%20with%20torn%20newsprint%20layers%2C%20deep%20crimson%20and%20warm%20cream%20paper%2C%20ink%20black%20geometric%20shapes%2C%20grainy%20risograph%20texture%2C%20dramatic%20diagonal%20composition%2C%20abstract%20artistic%20poster%20art%2C%20no%20readable%20text%2C%20high%20contrast&width=1920&height=1080&seq=cgbhl-hero-cover-01&orientation=landscape"
          alt="吃瓜爆黑料导航合辑封面主视觉"
          title="吃瓜爆黑料 导航合辑 封面"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/45 to-foreground-950/85"></div>

        <div className="relative z-10 flex h-full w-full items-center">
          <div className="mx-auto w-full max-w-[1360px] px-4 md:px-8">
            <div className="max-w-3xl animate-rise">
              <div className="flex items-center gap-3">
                <span className="h-px w-10 bg-accent-400"></span>
                <span className="text-xs tracking-[0.34em] text-accent-300">GUA · DIRECTORY</span>
              </div>

              <h1 className="mt-5 font-heading text-3xl leading-tight text-background-50 sm:text-4xl md:text-6xl">
                吃瓜爆黑料在哪看
                <span className="mt-3 block font-heading text-lg text-background-100 md:text-3xl">
                  这一页，先把入口排好顺序
                </span>
              </h1>

              <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
                找吃瓜爆黑料账号、频道与主页？这里整理导航与资源入口，快速定位最新爆料主页与观看渠道，不用再到处问人。
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#collections"
                  className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
                >
                  进入合辑索引
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </a>
                <a
                  href="#channels"
                  className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/45 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-background-50/10"
                >
                  查看账号频道
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 border-t border-background-50/20 bg-foreground-950/45 backdrop-blur-sm">
          <div className="mx-auto flex w-full max-w-[1360px] flex-col gap-1 px-4 py-3 text-xs text-background-100/80 sm:flex-row sm:items-center sm:justify-between md:px-8">
            <span className="tracking-wider">
              {issueMeta.issue} · {issueMeta.date}
            </span>
            <span className="tracking-wider">{issueMeta.slogan}</span>
          </div>
        </div>
      </div>
    </section>
  );
}